/* ArtSight cause figures. A unit (the copy of a figure, its drawing, the closing lines) is played when it scrolls into
   view and put back when it leaves through the bottom of the screen, so it plays again on the way back.
   The copy is played before its number can be read, so a number is never seen half counted.
   A drawing is played once a strip of it is on screen. The eased progress is written to --p on the unit and the
   stylesheet does the rest. Without JavaScript or with reduced motion every unit is already in its final state. */
(function () {
  if (window.asFiguresPlayLoaded) return;
  window.asFiguresPlayLoaded = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TAU = 300; // easing time constant, in milliseconds
  // A unit marked data-after-scroll waits for the visitor to start scrolling, even when it is already on screen at load.
  var scrolled = (window.pageYOffset || 0) > 8;
  window.addEventListener(
    'scroll',
    function () {
      if ((window.pageYOffset || 0) > 8) scrolled = true;
    },
    { passive: true }
  );

  function list(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function init(root) {
    if (!root || root.dataset.asFiguresInit || reduce) return;
    root.dataset.asFiguresInit = '1';

    var facts = list(root, '[data-fact]');
    var units = list(root, '[data-anim]').map(function (el) {
      return {
        el: el,
        enter: Number(el.getAttribute('data-enter') || 24), // pixels of the unit on screen before it is played
        tau: Number(el.getAttribute('data-tau') || TAU), // easing time constant of this unit (the timer drawing is 5 times slower)
        waits: el.hasAttribute('data-after-scroll'),
        shown: 0,
        last: -1,
        counts: list(el, '[data-count]')
      };
    });
    var running = false;
    var raf = 0;
    var before = 0;

    root.setAttribute('data-live', '');

    // One step of the animation: eases every unit towards its goal and writes --p. Returns true while something still moves.
    // It runs from requestAnimationFrame and also from scroll events: iOS Safari pauses requestAnimationFrame while a
    // finger is scrolling the page, scroll events keep coming. dt is the real elapsed time, so a late frame catches up.
    function step(now) {
      var vh = window.innerHeight || 1;
      var dt = Math.min(250, before ? Math.max(0, now - before) : 16);
      var moving = false;
      before = now;
      units.forEach(function (u) {
        var goal = vh - u.el.getBoundingClientRect().top >= u.enter && (scrolled || !u.waits) ? 1 : 0;
        u.shown += (goal - u.shown) * (1 - Math.exp(-dt / u.tau));
        if (Math.abs(goal - u.shown) < 0.002) u.shown = goal;
        else moving = true;
        var v = Math.round(u.shown * 1000) / 1000;
        if (v === u.last) return;
        u.last = v;
        u.el.style.setProperty('--p', v);
        u.counts.forEach(function (c) {
          var end = c.getAttribute('data-count');
          var decimals = (end.split('.')[1] || '').length;
          c.textContent = (Number(end) * v).toFixed(decimals);
        });
      });
      // The sentence of the title that the figures in view are proving
      var best = null;
      var bestDistance = Infinity;
      facts.forEach(function (el) {
        var box = el.getBoundingClientRect();
        var distance = Math.abs((box.top + box.bottom) / 2 - vh * 0.5);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = el;
        }
      });
      if (best && root.getAttribute('data-chapter') !== best.getAttribute('data-chapter')) {
        root.setAttribute('data-chapter', best.getAttribute('data-chapter'));
      }
      return moving;
    }

    function frame(now) {
      if (!root.isConnected) return; // the section was replaced in the Theme Editor
      var moving = step(now);
      raf = running || moving ? requestAnimationFrame(frame) : 0;
      if (!raf) before = 0;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!root.isConnected) return;
        // The observer that sets `running` is also late during a scroll on iOS: look at the section directly.
        var box = root.getBoundingClientRect();
        var vh = window.innerHeight || 1;
        if (box.bottom < -vh * 0.5 || box.top > vh * 1.5) return;
        step(performance.now());
        if (!raf) raf = requestAnimationFrame(frame);
      },
      { passive: true }
    );

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          running = entries[entries.length - 1].isIntersecting;
          if (running && !raf) raf = requestAnimationFrame(frame);
        },
        { rootMargin: '30% 0px 30% 0px' }
      ).observe(root);
    } else {
      running = true;
    }
    raf = requestAnimationFrame(frame);
  }

  function boot() {
    list(document, '[data-as-figures]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme Editor: start again after the section is rendered anew
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-as-figures]');
    if (!root) return;
    delete root.dataset.asFiguresInit;
    init(root);
  });
})();
